import { render, staticRenderFns } from "./CollapsePanel.vue?vue&type=template&id=6c4b6d12&scoped=true&"
import script from "./CollapsePanel.vue?vue&type=script&lang=js&"
export * from "./CollapsePanel.vue?vue&type=script&lang=js&"
import style0 from "./CollapsePanel.vue?vue&type=style&index=0&id=6c4b6d12&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4b6d12",
  null
  
)

export default component.exports